import React from "react";
import ReactMarkdown from "react-markdown";
import styles from "./MerchantCenterViewer.module.css";
import checkIcon from "../../../assets/icons/check-icon.png";
import { renderParagraphs } from "./utils.jsx";

const parseSummaryLines = (markdown = "") => {
  const match = String(markdown || "").match(/Summary:\s*([\s\S]*)$/i);
  if (!match) return [];
  return String(match[1] || "")
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean)
    .map((line) => line.replace(/^[-\u2022]\s*/, ""))
    .filter((line) => !/^\*\*.*assessment.*\*\*$/i.test(line));
};

const MerchantCenterAssessmentViewerV2 = ({ markdown }) => {
  if (!markdown) return null;
  const summaryLines = parseSummaryLines(markdown);

  return (
    <div className={styles.card}>
      <div className={styles.hero}>
        <div className={styles.heroLeft}>
          <div className={styles.heroIcon}>
            <img src={checkIcon} alt="check" className={styles.checkIconImg} />
          </div>
          <h4 className={styles.heroTitle}>Trust Checklist</h4>
        </div>
        <p className={styles.heroSubtitle}>
          Trust, policy, and product quality insights
        </p>
      </div>

      {summaryLines.length > 0 ? (
        <div className={styles.sectionContainer}>
          <div className={styles.sectionHeader}>ANALYSIS</div>
          <div className={styles.analysisContent}>
            {summaryLines.map((line, idx) => (
              <div className={styles.analysisItem} key={`summary-${idx}`}>
                <span className={styles.summaryCheck} />
                <ReactMarkdown
                  components={{
                    p: ({ children }) => (
                      <span className={styles.analysisText}>{children}</span>
                    ),
                    strong: ({ children }) => (
                      <strong style={{ fontWeight: 700 }}>{children}</strong>
                    ),
                  }}
                >
                  {line}
                </ReactMarkdown>
              </div>
            ))}
          </div>
        </div>
      ) : (
        renderParagraphs(markdown, styles)
      )}
    </div>
  );
};

export default MerchantCenterAssessmentViewerV2;
